import * as React from 'react';
import * as EmailValidator from 'email-validator';

import { localization } from '../localization/localization';

export interface IEmailInputProps {
    email: string;
    onEmailChanged(email: string, isValid: boolean, showError: boolean): void;
    placeholder: string;
    disabled: boolean;
    onPressEnter?(email: string, isValid: boolean, showError: boolean): void;
}

interface IState {
    emailIsValid: boolean;
    emailShowError: boolean;
}

export class EmailInput extends React.Component<IEmailInputProps, IState> {
    constructor(props: IEmailInputProps) {
        super(props);

        this.state = {
            emailIsValid: false,
            emailShowError: false
        };
    }

    public componentWillMount() {
        // trigger initial validation
        this.onEmailChanged(this.props.email);
    }

    private onEmailChanged(value: string) {
        const isValid = EmailValidator.validate(value);
        this.setState({
            emailIsValid: isValid
        });

        this.props.onEmailChanged(value, isValid, this.state.emailShowError);
    }

    private onBlur() {
        this.setState({
            emailShowError: true
        });

        const isValid = EmailValidator.validate(this.props.email);
        this.props.onEmailChanged(this.props.email, isValid, true);
    }

    private handleKeyPress(e: React.KeyboardEvent<HTMLInputElement>): void {
        if (e.key === 'Enter') {
            if (this.props.onPressEnter) {
                const isValid = EmailValidator.validate(this.props.email);
                this.props.onPressEnter(this.props.email, isValid, this.state.emailShowError);
            }
        }
    }

    public render() {
        return (
            <div className="input-with-validation">
                <input type="text"
                    required={true}
                    className={'form-control email-input promotron-troneditor-allow-writing '  + ((!this.state.emailIsValid && this.state.emailShowError) ?  'input-invalid' : '')}
                    placeholder={localization.uploadLoc.dtpRequest.placeholder}
                    value={this.props.email}
                    onChange={(e) => this.onEmailChanged(e.target.value)}
                    onBlur={() => this.onBlur()}
                    onKeyPress={e => this.handleKeyPress(e)}
                    disabled={this.props.disabled}
                    />
            </div>
        );
    }    
}



// WEBPACK FOOTER //
// ./src/App/shared/components/email-input.component.tsx